export default {
  permissions: [],
  all_permission: []
}



// WEBPACK FOOTER //
// ./src/store/module/group-permission/state.js